import module from 'fan/proyecto/module.js'
import template from './template.html'
import * as moment from 'moment'
import { orderBy } from 'lodash'

export class FanProyectoColaboradoresIDSEHistorialItemComponent {
  proyectoId
  data
  onDelete
  fecha = ''
  descargando = false
  movimientos = null
  expandido = false

  constructor (FanProyectoColaboradoresIDSEHistorialMovimientosService, FanProyectoColaboradoresIDSEArchivoService) {
    this.FanProyectoColaboradoresIDSEHistorialMovimientosService = FanProyectoColaboradoresIDSEHistorialMovimientosService
    this.FanProyectoColaboradoresIDSEArchivoService = FanProyectoColaboradoresIDSEArchivoService
  }

  $onInit () {
    this.fecha = moment(this.data.fecha).format('LL')
  }

  actualizar ({eliminado}) {
    this.eliminando = false

    if (eliminado) {
      this.movimientos = this.movimientos.filter((item) => item !== this.seleccionado)
    }

    this.data.movimientos = this.movimientos.length

    if (!this.movimientos.length) {
      this.onDelete({$event: {detail: this.data.idse_id}})
    }
  }

  eliminar (movimiento) {
    this.eliminando = true
    this.seleccionado = movimiento
  }

  descargar () {
    if (this.descargando) return

    this.descargando = true

    this.FanProyectoColaboradoresIDSEArchivoService.get(this.data.proyecto_id, this.data.idse_id, this.data.id_tipo_movimiento)
      .then(({data}) => (data.save()))
      .finally(() => (this.descargando = false))
  }

  toggleExpandido () {
    this.expandido = !this.expandido

    if (this.expandido) {
      this.FanProyectoColaboradoresIDSEHistorialMovimientosService.get(this.data.proyecto_id, this.data.idse_id)
        .then(({data}) => (this.movimientos = orderBy(data, ['colaborador'])))
    } else {
      this.movimientos = null
    }
  }
}

module.component('fanProyectoColaboradoresIdseHistorialItem', {
  controller: FanProyectoColaboradoresIDSEHistorialItemComponent,
  template,
  bindings: {
    proyectoId: '<',
    data: '<',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/idse/historial/item/component.js